import { createRouter, createWebHistory } from 'vue-router';
import LoginPage from '../components/Login.vue';
import HomePage from '../components/Home.vue';
import ProfilePage from '../components/Profile.vue';
import CustomerForm from '../components/CustomerForm.vue';
import CropForm from '../components/CropForm.vue';
import CustomerRateForm from '../components/CustomerRateForm.vue';
import BagPitTypeForm from '../components/BagPitTypeForm.vue';
import CustomerBagPitForm from '../components/CustomerBagPitForm.vue';
import CompanyInfoForm from '../components/CompanyInfoForm.vue';
import HaulerForm from '../components/HaulerForm.vue';
import DriverForm from '../components/DriverForm.vue';
import FeedForm from '../components/FeedForm.vue';
import ProducerForm from '../components/ProducerForm.vue';
import FeedmillForm from '../components/FeedmillForm.vue';
import ProducerRateForm from '../components/ProducerRateForm.vue';
import ProducerAreaForm from '../components/ProducerAreaForm.vue';
import ProducerAreaRateForm from '../components/ProducerAreaRateForm.vue';
import ProducerFeedmillRateForm from '../components/ProducerFeedmillRateForm.vue';
import MileForm from '../components/MileForm.vue';
import FieldForm from '../components/FieldForm.vue';
import JobForm from '../components/JobForm.vue';
import TruckForm from '../components/TruckForm.vue';
import TicketCropForm from '../components/TicketCropForm.vue';
import TicketDeliveryForm from '../components/TicketDeliveryForm.vue';
import TicketHaulForm from '../components/TicketHaulForm.vue';
import CropTable from '../components/CropTable.vue';
import CustomerTable from '../components/CustomerTable.vue';
import CustomerRateTable from '../components/CustomerRateTable.vue';
import BagPitTypeTable from '../components/BagPitTypeTable.vue';
import CustomerBagPitTable from '../components/CustomerBagPitTable.vue';
import HaulerTable from '../components/HaulerTable.vue';
import DriverTable from '../components/DriverTable.vue';
import TruckTable from '../components/TruckTable.vue';
import MileTable from '../components/MileTable.vue';
import ProducerAreaTable from '../components/ProducerAreaTable.vue';
import ProducerTable from '../components/ProducerTable.vue';
import FeedmillTable from '../components/FeedmillTable.vue';
import ProducerRateTable from '../components/ProducerRateTable.vue';
import ProducerAreaRateTable from '../components/ProducerAreaRateTable.vue';
import FieldTable from '../components/FieldTable.vue';
import FeedTable from '../components/FeedTable.vue';
import TicketCropTable from '../components/TicketCropTable.vue';
import TicketDeliveryTable from '../components/TicketDeliveryTable.vue';
import TicketHaulTable from '../components/TicketHaulTable.vue';
import JobTable from '../components/JobTable.vue';
import ReportRunner from '../components/ReportRunner.vue';
import { isLoggedIn } from '../utils/auth';

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: LoginPage
  },
  {
    path: '/',
    name: 'HomePage',
    component: HomePage,
    meta: { requiresAuth: true, title: 'Home' }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: ProfilePage,
    meta: { requiresAuth: true, title: 'Profile' }
  },
  {
    path: '/customers/add',
    name: 'AddCustomer',
    component: CustomerForm,
    meta: { requiresAuth: true, title: 'New Customer' }
  },
  {
    path: '/customers/edit/:customerId',
    name: 'EditCustomer',
    component: CustomerForm,
    meta: { requiresAuth: true, title: 'Edit Customer'},
    props: true // This will pass the customerId as a prop to the component
  },
  {
    path: '/crops/add',
    name: 'AddCrop',
    component: CropForm,
    meta: { requiresAuth: true, title: 'New Crop' }
  },
  {
    path: '/crop/edit/:cropId',
    name: 'EditCrop',
    component: CropForm,
    meta: { requiresAuth: true, title: 'Edit Crop'},
    props: true // This will pass the id as a prop to the component
  },
  {
    path: '/customer_rates/add',
    name: 'AddCustomerRate',
    component: CustomerRateForm,
    meta: { requiresAuth: true, title: 'New Customer Rate' }
  },
  {
    path: '/customer_rates/edit/:customerRateId',
    name: 'EditCustomerRate',
    component: CustomerRateForm,
    meta: { requiresAuth: true, title: 'Edit Customer Rate'},
    props: true
  },
  {
    path: '/bag_pit_type/add',
    name: 'AddBagPitType',
    component: BagPitTypeForm,
    meta: { requiresAuth: true, title: 'New Bag Pit Type' }
  },
  {
    path: '/bag_pit_type/edit/:bagPitTypeId',
    name: 'EditBagPitType',
    component: BagPitTypeForm,
    meta: { requiresAuth: true, title: 'Edit Bag Pit Type'},
    props: true
  },
  {
    path: '/customer_bag_pit/add',
    name: 'AddCustomerBagPit',
    component: CustomerBagPitForm,
    meta: { requiresAuth: true, title: 'New Customer Bag Pit' }
  },
  {
    path: '/customer_bag_pit/edit/:customerBagPitId',
    name: 'EditCustomerBagPit',
    component: CustomerBagPitForm,
    meta: { requiresAuth: true, title: 'Edit Customer Bag Pit'},
    props: true
  },
  {
    path: '/company_info/add',
    name: 'AddCompanyInfo',
    component: CompanyInfoForm,
    meta: { requiresAuth: true, title: 'New Company Info' }
  },
  {
    path: '/company_info/edit/:companyInfoId',
    name: 'EditCompanyInfo',
    component: CompanyInfoForm,
    meta: { requiresAuth: true, title: 'Edit Company Info'},
    props: true
  },
  {
    path: '/hauler/add',
    name: 'AddHauler',
    component: HaulerForm,
    meta: { requiresAuth: true, title: 'New Hauler' }
  },
  {
    path: '/hauler/edit/:haulerId',
    name: 'EditHauler',
    component: HaulerForm,
    meta: { requiresAuth: true, title: 'Edit Hauler'},
    props: true
  },
  {
    path: '/driver/add',
    name: 'AddDriver',
    component: DriverForm,
    meta: { requiresAuth: true, title: 'New Driver' }
  },
  {
    path: '/driver/edit/:driverId',
    name: 'EditDriver',
    component: DriverForm,
    meta: { requiresAuth: true, title: 'Edit Driver'},
    props: true
  },
  {
    path: '/feed/add',
    name: 'AddFeed',
    component: FeedForm,
    meta: { requiresAuth: true, title: 'New Feed' }
  },
  {
    path: '/feed/edit/:feedId',
    name: 'EditFeed',
    component: FeedForm,
    meta: { requiresAuth: true, title: 'Edit Feed'},
    props: true
  },
  {
    path: '/feedmill/add',
    name: 'AddFeedmill',
    component: FeedmillForm,
    meta: { requiresAuth: true, title: 'New Feedmill' }
  },
  {
    path: '/feedmill/edit/:feedmillId',
    name: 'EditFeedmill',
    component: FeedmillForm,
    meta: { requiresAuth: true, title: 'Edit Feedmill'},
    props: true
  },
  {
    path: '/producer/add',
    name: 'AddProducer',
    component: ProducerForm,
    meta: { requiresAuth: true, title: 'New Producer' }
  },
  {
    path: '/producer/edit/:producerId',
    name: 'EditProducer',
    component: ProducerForm,
    meta: { requiresAuth: true, title: 'Edit Producer'},
    props: true
  },
  {
    path: '/producer_area/add',
    name: 'AddProducerArea',
    component: ProducerAreaForm,
    meta: { requiresAuth: true, title: 'New Producer Area' }
  },
  {
    path: '/producer_area/edit/:producerAreaId',
    name: 'EditProducerArea',
    component: ProducerAreaForm,
    meta: { requiresAuth: true, title: 'Edit Producer Area'},
    props: true
  },
  {
    path: '/producer_area_rate/add',
    name: 'AddProducerAreaRate',
    component: ProducerAreaRateForm,
    meta: { requiresAuth: true, title: 'New Producer Area Rate' }
  },
  {
    path: '/producer_area_rate/edit/:producerAreaRateId',
    name: 'EditProducerAreaRate',
    component: ProducerAreaRateForm,
    meta: { requiresAuth: true, title: 'Edit Producer Area Rate'},
    props: true
  },
  {
    path: '/producer_rate/add',
    name: 'AddProducerRate',
    component: ProducerRateForm,
    meta: { requiresAuth: true, title: 'New Producer Rate' }
  },
  {
    path: '/producer_rate/edit/:producerRateId',
    name: 'EditProducerRate',
    component: ProducerRateForm,
    meta: { requiresAuth: true, title: 'Edit Producer Rate'},
    props: true
  },

  {
    path: '/producer_feedmill_rate/add',
    name: 'AddProducerFeedmillRate',
    component: ProducerFeedmillRateForm,
    meta: { requiresAuth: true, title: 'New Producer Feedmill Rate' }
  },
  {
    path: '/producer_feedmill_rate/edit/:producerFeedmillRateId',
    name: 'EditProducerFeedmillRate',
    component: ProducerFeedmillRateForm,
    meta: { requiresAuth: true, title: 'Edit Producer Feedmill Rate'},
    props: true
  },
  {
    path: '/miles/add',
    name: 'AddMiles',
    component: MileForm,
    meta: { requiresAuth: true, title: 'New Mileage' }
  },
  {
    path: '/miles/edit/:mileId',
    name: 'EditMiles',
    component: MileForm,
    meta: { requiresAuth: true, title: 'Edit Mileage'},
    props: true
  },
  {
    path: '/field/add',
    name: 'AddField',
    component: FieldForm,
    meta: { requiresAuth: true, title: 'New Field' }
  },
  {
    path: '/field/edit/:fieldId',
    name: 'EditField',
    component: FieldForm,
    meta: { requiresAuth: true, title: 'Edit Field'},
    props: true
  },
  {
    path: '/job/add',
    name: 'AddJob',
    component: JobForm,
    meta: { requiresAuth: true, title: 'New Job' }
  },
  {
    path: '/job/edit/:jobId',
    name: 'EditJob',
    component: JobForm,
    meta: { requiresAuth: true, title: 'Edit Job'},
    props: true
  },
  {
    path: '/truck/add',
    name: 'AddTruck',
    component: TruckForm,
    meta: { requiresAuth: true, title: 'New Truck' }
  },
  {
    path: '/truck/edit/:truckId',
    name: 'EditTruck',
    component: TruckForm,
    meta: { requiresAuth: true, title: 'Edit Truck'},
    props: true
  },
  {
    path: '/crop_ticket/add/:jobId',
    name: 'AddCropTicket',
    component: TicketCropForm,
    meta: { requiresAuth: true, title: 'New Crop Ticket' },
    props: true
  },
  {
    path: '/crop_ticket/edit/:ticketId',
    name: 'EditCropTicket',
    component: TicketCropForm,
    meta: { requiresAuth: true, title: 'Edit Crop Ticket'},
  },
  {
    path: '/delivery_ticket/add',
    name: 'AddDeliveryTicket',
    component: TicketDeliveryForm,
    meta: { requiresAuth: true, title: 'New Delivery Ticket' },
    props: true
  },
  {
    path: '/delivery_ticket/edit/:ticketId',
    name: 'EditDeliveryTicket',
    component: TicketDeliveryForm,
    meta: { requiresAuth: true, title: 'Edit Delivery Ticket'},
    props: true
  },
  {
    path: '/haul_ticket/add',
    name: 'AddHaulTicket',
    component: TicketHaulForm,
    meta: { requiresAuth: true, title: 'New Haul Ticket' },
    props: true
  },
  {
    path: '/haul_ticket/edit/:ticketId',
    name: 'EditHaulTicket',
    component: TicketHaulForm,
    meta: { requiresAuth: true, title: 'Edit Haul Ticket'},
    props: true
  },
  {
    path: '/crops/list',
    name: 'ListCrops',
    component: CropTable,
    meta: { requiresAuth: true, title: 'Crops' }
  },
  {
    path: '/customers/list',
    name: 'ListCustomers',
    component: CustomerTable,
    meta: { requiresAuth: true, title: 'Customers' }
  },
  {
    path: '/customer_rates/list',
    name: 'ListCustomerRates',
    component: CustomerRateTable,
    meta: { requiresAuth: true, title: 'Customer Rates' }
  },
  {
    path: '/bag_pit_types/list',
    name: 'ListBagPitTypes',
    component: BagPitTypeTable,
    meta: { requiresAuth: true, title: 'Bag Pit Types' }
  },
  {
    path: '/customer_bag_pits/list',
    name: 'ListCustomerBagPits',
    component: CustomerBagPitTable,
    meta: { requiresAuth: true, title: 'Bag Pit Types' }
  },
  {
    path: '/haulers/list',
    name: 'ListHaulers',
    component: HaulerTable,
    meta: { requiresAuth: true, title: 'Haulers' }
  },
  {
    path: '/drivers/list',
    name: 'ListDrivers',
    component: DriverTable,
    meta: { requiresAuth: true, title: 'Drivers' }
  },
  {
    path: '/trucks/list',
    name: 'ListTrucks',
    component: TruckTable,
    meta: { requiresAuth: true, title: 'Trucks' }
  },
  {
    path: '/producer_areas/list',
    name: 'ListProducerAreas',
    component: ProducerAreaTable,
    meta: { requiresAuth: true, title: 'Producer Areas' }
  },
  {
    path: '/producers/list',
    name: 'ListProducers',
    component: ProducerTable,
    meta: { requiresAuth: true, title: 'Producers' }
  },
  {
    path: '/feedmills/list',
    name: 'ListFeedmills',
    component: FeedmillTable,
    meta: { requiresAuth: true, title: 'Feedmills' }
  },
  {
    path: '/producer_rates/list',
    name: 'ListProducerRates',
    component: ProducerRateTable,
    meta: { requiresAuth: true, title: 'Producer Rates' }
  },
  {
    path: '/producer_area_rates/list',
    name: 'ListProducerAreaRates',
    component: ProducerAreaRateTable,
    meta: { requiresAuth: true, title: 'Producer Area Rates' }
  },
  {
    path: '/fields/list',
    name: 'ListFields',
    component: FieldTable,
    meta: { requiresAuth: true, title: 'Fields' }
  },
  {
    path: '/miles/list',
    name: 'ListMiles',
    component: MileTable,
    meta: { requiresAuth: true, title: 'Miles' }
  },
  {
    path: '/feed/list',
    name: 'ListFeed',
    component: FeedTable,
    meta: { requiresAuth: true, title: 'Feed' }
  },
  {
    path: '/ticket_crop/list',
    name: 'ListTicketsCrop',
    component: TicketCropTable,
    meta: { requiresAuth: true, title: 'Crop Tickets' }
  },
  {
    path: '/ticket_delivery/list',
    name: 'ListTicketsDelivery',
    component: TicketDeliveryTable,
    meta: { requiresAuth: true, title: 'Delivery Tickets' }
  },
  {
    path: '/ticket_haul/list',
    name: 'ListTicketsHaul',
    component: TicketHaulTable,
    meta: { requiresAuth: true, title: 'Haul Tickets' }
  },
  {
    path: '/jobs/list',
    name: 'ListJob',
    component: JobTable,
    meta: { requiresAuth: true, title: 'Jobs' }
  },
  {
    path: '/report_runner',
    name: 'ReportRunner',
    component: ReportRunner,
    meta: { requiresAuth: true, title: 'Reports' }
  },
  {
    path: '/report-not-found',
    name: 'ReportNotFound',
    component: () => import('../components/ReportNotFound.vue'),
    meta: { title: 'Report Not Found' }
  },
  {
  path: '/:catchAll(.*)',
  name: 'NotFound',
  component: () => import('../components/Error404Page.vue'),
  meta: { title: 'Page Not Found' }
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// Navigation guard to check for auth before entering routes
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLoggedIn.value) {
      next({ name: 'Login' });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
